import React from 'react';
import { Collapse, Flex, Button, Divider } from '@costar/theme-ui';
import { enabledButtonsSelector } from './selectors/enabled-buttons-selector.esm.js';
import { showSelectedFooterSelector } from './selectors/show-selected-footer-selector.esm.js';

function SelectListFooter(props) {
  var buttonsEnabled = enabledButtonsSelector(props);
  return /*#__PURE__*/React.createElement(Collapse, {
    "in": showSelectedFooterSelector(props)
  }, /*#__PURE__*/React.createElement(Flex, {
    relative: true,
    border: "neutral.medium",
    boxShadow: "defaultRaiseTop",
    flexDirection: "column",
    justifyContent: "center",
    width: "100%",
    "automation-id": "csg-trl-fields-btn-group"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "ghost",
    disabled: !buttonsEnabled.save,
    onClick: props.onSaveClick,
    justifyContent: "center",
    "automation-id": "csg-trl-btn-save"
  }, props.resources.buttons.save()), /*#__PURE__*/React.createElement(Divider, {
    width: "100%"
  }), /*#__PURE__*/React.createElement(Button, {
    variant: "ghost",
    disabled: !buttonsEnabled.saveAs,
    onClick: props.onSaveAsClick,
    justifyContent: "center",
    "automation-id": "csg-trl-btn-save-as"
  }, props.resources.buttons.saveAs()), /*#__PURE__*/React.createElement(Divider, {
    width: "100%"
  }), /*#__PURE__*/React.createElement(Button, {
    variant: "ghostDanger",
    disabled: !buttonsEnabled["delete"],
    onClick: props.onDeleteClick,
    justifyContent: "center",
    "automation-id": "csg-trl-btn-delete"
  }, props.resources.buttons["delete"]())));
}

export { SelectListFooter };
//# sourceMappingURL=select-list-footer.esm.js.map
